import { useEffect, useState } from 'react';

import { decryptSensitiveData } from '@lcsc-design/utils/crypto';
import { Form, Input, Button, message } from 'antd';

import { ModalWrapper } from './style';

import { arriveInit, arriveInsert } from '@/apis/member';
import Utils from '@/utils/Utils';

// 到货通知弹窗
export default function ArrivalNotice({ open, product, onCancel }) {
  const [isOpen, setIsOpen] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => {
    if (open) {
      init();
    } else {
      setIsOpen(false);
    }
  }, [open, product]);
  // 初始化
  function init() {
    arriveInit().then(async ({ code, result, needLogin }) => {
      if (needLogin) {
        Utils.showWindowLogin();
      } else if (code === 200) {
        const email = await decryptSensitiveData(result?.email);
        const phone = await decryptSensitiveData(result?.mobile);
        form.setFieldsValue({
          email,
          phone,
        });
        setIsOpen(true);
      }
    });
  }
  // 提交
  async function submit() {
    const fields = await form.validateFields();
    const params = {
      productId: product?.productId,
      ...fields,
    };
    arriveInsert(params).then((res) => {
      if (res?.needLogin) {
        Utils.showWindowLogin();
      } else if (res?.code === 200) {
        message.success(res?.msg);
        onCancel();
      }
    });
  }

  return (
    <ModalWrapper
      title="到货通知"
      open={isOpen}
      centered
      width={505}
      footer={false}
      onCancel={onCancel}
      maskClosable={false}
    >
      <p className="m-[8px_0_15px] text-[#55637D]">若商品到货，我们会通过邮件或短信来通知你哦~</p>
      <Form form={form}>
        <Form.Item
          label="手机号码"
          name="phone"
          rules={[
            { required: true, message: '请输入手机号码' },
            { pattern: /^[1][0-9]{10}$/, message: '格式不正确' },
          ]}
          validateTrigger="onBlur"
        >
          <Input className="!w-[185px]" />
        </Form.Item>
        <Form.Item
          label="邮箱地址"
          name="email"
          rules={[
            { required: true, message: '请输入邮箱地址' },
            {
              pattern: /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/,
              message: '格式不正确',
            },
          ]}
          validateTrigger="onBlur"
        >
          <Input className="!w-[185px]" />
        </Form.Item>
      </Form>
      <div className="text-right">
        <Button type="primary" onClick={submit}>
          确定
        </Button>
      </div>
    </ModalWrapper>
  );
}
